import React from 'react'

import { Container, Row } from '../../components/Bootstrap'
import ColumnList from '../../components/ColumnList'
import Panel from '../../components/Panel'

import { colours } from '../../theme'

import house from '../../images/house.svg'

const Context = () => (
	<>
		<Container>
			<Row className="justify-content-end pt-5">
				<img src={house} alt="" style={{ marginBottom: '0', verticalAlign: 'top' }} />
			</Row>
		</Container>
		<Panel colour={colours.primary} style={{ marginTop: 0 }}>
			<Container>
				<h2>Setting the Context</h2>
				<ColumnList>
					<li>Contribute to the achievement of social and economic equity in collaboration with people with disabilities through an inclusive approach.</li>
					<li>CILT serves consumers in the Greater Toronto area and region, and in all of Ontario for the delivery of the Direct Funding Program and the Student Attendant Service Fund. The primary disability addressed is physical including both visible and invisible disabilities, mobility, sensory and communication barriers.</li>
					<li>CILT 2025 Strategy is meant to address the changing needs of people with disabilities by empowering people with disabilities, enhancing strategic partnerships and leveraging evidence based research and participatory action.</li>
					<li>CILT is officially in its 35th year of operation. It opened its doors in October 1984 after conducting a consumer needs survey to assess needs of the community.</li>
					<li>As needs grow, CILT remains committed to be at the forefront of putting consumers first by focusing on consumers’ needs and rights, quality improvements and value for money in its programs/services.</li>
				</ColumnList>
			</Container>
		</Panel>
	</>
)

export default Context
